// Shared water-type / sub-type options used by both the Enrollment setup and
// the dashboard's User Preferences editor, so the two stay in sync.
//
// Anglers fish saltwater, freshwater, or both. Each water type has two
// sub-types. The sub-type IDs ("inshore"/"offshore", "river"/"lake") are the
// source of truth consumed elsewhere (e.g. useFlowStage / seasonPhase treat
// "river" vs "lake" differently) — do not rename IDs without updating readers.

export const WATER_TYPE_OPTIONS = [
  { id: "saltwater", label: "Saltwater" },
  { id: "freshwater", label: "Freshwater" },
];

export const SUBTYPE_OPTIONS = {
  saltwater: [
    { id: "inshore", label: "Inshore", help: "Bays, flats, estuaries, jetties." },
    { id: "offshore", label: "Offshore", help: "Bluewater, reefs, deep wrecks." },
  ],
  freshwater: [
    { id: "river", label: "River", help: "Moving water — rivers, creeks, tailwaters." },
    { id: "lake", label: "Lake", help: "Lakes, ponds, reservoirs." },
  ],
};

// Given selected water types + sub-types, build the Firestore payload fields
// (with legacy single-value back-compat), dropping any sub-types that don't
// belong to a currently-selected water type.
export function buildWaterTypePayload(waterTypes, subTypes) {
  const wt = (Array.isArray(waterTypes) ? waterTypes : [])
    .map((w) => String(w || "").toLowerCase())
    .filter(Boolean);
  const validSubIds = wt.flatMap((w) => (SUBTYPE_OPTIONS[w] || []).map((o) => o.id));
  const cleanedSubs = (Array.isArray(subTypes) ? subTypes : [])
    .map((s) => String(s || "").toLowerCase())
    .filter((id) => validSubIds.includes(id));
  return {
    waterTypes: wt,
    // Legacy single field: "both" when dual-enrolled so freshwater-only
    // readers don't mistakenly disable tides.
    waterType: wt.length === 1 ? wt[0] : wt.length === 0 ? "" : "both",
    subTypes: cleanedSubs,
    subType: cleanedSubs[0] || "",
  };
}
